import { render, staticRenderFns } from "./LanguageUploadModal.vue?vue&type=template&id=410cadf2&scoped=true"
import script from "./LanguageUploadModal.vue?vue&type=script&lang=js"
export * from "./LanguageUploadModal.vue?vue&type=script&lang=js"
import style0 from "./LanguageUploadModal.vue?vue&type=style&index=0&id=410cadf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410cadf2",
  null
  
)

export default component.exports